var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrAbajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 30.12L20.93 23.05L19.51 24.46L28 32.95L36.49 24.46L35.07 23.05L28 30.12Z",
    fill: "#002747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrAbajo);
export default __webpack_public_path__ + "static/media/ir_abajo.c8c16ddfffb437430b9d2b7b0ed49d14.svg";
export { ForwardRef as ReactComponent };